import { combineReducers } from 'redux';

import auth from './auth';
import user from './user';
import pet from './pet';
import statsbar from './statsbar';
import redemption from './redemption';
import transaction from './transaction';
import media from './media';
import tiers from './member-tiers';
import journey from './journey';
import organization from './organization';
import activity from './activity';
import reward from './reward';
import invoice from './invoice';
import promotion from './promotion';
import product from './product';
import location from './purchase-location';
import ipwhitelist from './ip-whitelist';
import salesforce from './salesforce-import';
import table from './table';

const reducer = combineReducers({
  auth,
  user,
  pet,
  statsbar,
  redemption,
  transaction,
  media,
  tiers,
  journey,
  organization,
  activity,
  reward,
  invoice,
  promotion,
  product,
  location,
  ipwhitelist,
  salesforce,
  table,
});

export default reducer;
